import React from 'react';
const StickyBar = ({ text, image }) => (<div className="shadow-sm sticky-top-md bg-white">
        <div className="container py-6">
            <div className="row justify-content-md-center no-gutters">
                <div className="col-6 col-md-9 col-lg-7 col-xl-6 text-center my-auto">{text}</div>
                {image && <div className="col-6 col-sm-2 my-auto text-center">{image}</div>}
            </div>
        </div>
    </div>);
export default StickyBar;
